<template>
  <el-table
        stripe
    size="mini"
    :data="tableData"
    height="100%"
    :class="{'dark':skinType}"
    :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
  >
    <el-table-column v-for="(col,index) of tableColumn"
    min-width="88"
    :key="index" :prop="col" :fixed="col=='type'?'fixed':false"
     :label="col=='type'?'类型':col" align="center">
    </el-table-column>
  </el-table>
</template>
<script>
import { GetDianNengXiaoHaoForBarChart } from '../../../api/enery-analysis/eneryanalysis';

export default {
  data() {
    return {
      tableData: [],
      tableColumn: [],
    };
  },
  props: {
    proId: String,
    selectPeriod: Array,
    periodType: String,
  },
  watch: {
    proId() {
      this.requestData();
    },
    selectPeriod() {
      this.requestData();
    },
  },
  created() {
    this.requestData();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 设置指定行、列、具体单元格颜色
    requestData() {
      if (!this.proId) {
        return;
      }
      const [start, end] = this.selectPeriod;
      GetDianNengXiaoHaoForBarChart({
        StationIdStr: this.proId,
        DateType: this.periodType,
        BeginDate: start,
        EndDate: end,
      })
        .then((res) => {
          this.tableData = res.fenquData.tableData;
          if (res.fenquData.tableColumn.length > 0) {
            res.fenquData.tableColumn.unshift('type');
          }
          this.tableColumn = res.fenquData.tableColumn;
        }).catch(() => {
          this.tableData = [];
          this.tableColumn = [];
        });
    },
    cellStyle({
      rowIndex, columnIndex,
    }) {
      if (rowIndex === 0 && columnIndex === 0) { // 指定坐标rowIndex ：行，columnIndex ：列
        return 'color:#019dd8'; // rgb(105,0,7)
      } if (rowIndex === 1 && columnIndex === 0) {
        return 'color:#8d9eae';
      } if (rowIndex === 2 && columnIndex === 0) {
        return 'color:#0bd0d9';
      } if (rowIndex === 3 && columnIndex === 0) {
        return 'color:#0f6fc6';
      }
      return '';
    },
  },
};
</script>
<style scoped>
table {
  background: #898a8a;
}
</style>
